import React from 'react';
import Utils from "../../../../../utils/Utils";

interface Props {
    productView: Record<string, any>;
}

const ProductDescription = ({productView}: Props) => {
    if (!productView.content && !productView.description) return <></>;

    if (productView.content) {
        return (
            <p className="product-description"
               dangerouslySetInnerHTML={{__html: Utils.nl2brString(productView.content)}}/>
        )
    }

    return (
        <p className="product-description"
           dangerouslySetInnerHTML={{__html: Utils.nl2brString(productView.description)}}/>
    )
}

export default ProductDescription;